import { DASHBOARD_TYPE } from 'domain/entity/reportTemplate';
import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface GetDashboardsCriteria {
    sort?: string;
    order?: string;
    dashboardType: DASHBOARD_TYPE;
}

class GetDashboardsCriteriaImpl implements GetDashboardsCriteria {
    constructor(readonly dashboardType: DASHBOARD_TYPE, readonly sort?: string, readonly order?: string) {}
}

export class GetDashboardsCriteriaBuilder {
    private sort: Option<string | undefined> = none;

    private order: Option<string | undefined> = none;

    private dashboardType: DASHBOARD_TYPE = DASHBOARD_TYPE.DASHBOARD;

    static create = (): GetDashboardsCriteriaBuilder => new GetDashboardsCriteriaBuilder();

    withSort = (sort?: string): GetDashboardsCriteriaBuilder => {
        this.sort = some(sort);
        return this;
    };

    withOrder = (order?: string): GetDashboardsCriteriaBuilder => {
        this.order = some(order);
        return this;
    };

    withDashboardsType = (dashboardType: DASHBOARD_TYPE): GetDashboardsCriteriaBuilder => {
        this.dashboardType = dashboardType;
        return this;
    };

    build = (): GetDashboardsCriteria =>
        new GetDashboardsCriteriaImpl(
            this.dashboardType,
            isNone(this.sort) || this.sort === undefined ? undefined : this.sort.value,
            isNone(this.order) || this.order === undefined ? undefined : this.order.value
        );
}
